import { render, staticRenderFns } from "./FeaturesForm.vue?vue&type=template&id=691a5956&"
import script from "./FeaturesForm.vue?vue&type=script&lang=js&"
export * from "./FeaturesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports